/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReportTabFromJSON, ApiReportTabToJSON, } from './ApiReportTab';
import { ApiTabChartFromJSON, ApiTabChartToJSON, } from './ApiTabChart';
import { ApiTabElementTypeFromJSON, ApiTabElementTypeToJSON, } from './ApiTabElementType';
export function ApiTabElementFromJSON(json) {
    return ApiTabElementFromJSONTyped(json, false);
}
export function ApiTabElementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiTabChartFromJSON(json['chart']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'elements': !exists(json, 'elements') ? undefined : (json['elements'].map(ApiTabElementFromJSON)),
        'h': !exists(json, 'h') ? undefined : json['h'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'parentElement': !exists(json, 'parentElement') ? undefined : ApiTabElementFromJSON(json['parentElement']),
        'parentElementId': !exists(json, 'parentElementId') ? undefined : json['parentElementId'],
        'reportTabId': !exists(json, 'reportTabId') ? undefined : json['reportTabId'],
        'tab': !exists(json, 'tab') ? undefined : ApiReportTabFromJSON(json['tab']),
        'type': !exists(json, 'type') ? undefined : ApiTabElementTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'w': !exists(json, 'w') ? undefined : json['w'],
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
    };
}
export function ApiTabElementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiTabChartToJSON(value.chart),
        'description': value.description,
        'elements': value.elements === undefined ? undefined : (value.elements.map(ApiTabElementToJSON)),
        'h': value.h,
        'id': value.id,
        'level': value.level,
        'name': value.name,
        'parentElement': ApiTabElementToJSON(value.parentElement),
        'parentElementId': value.parentElementId,
        'reportTabId': value.reportTabId,
        'tab': ApiReportTabToJSON(value.tab),
        'type': ApiTabElementTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'w': value.w,
        'x': value.x,
        'y': value.y,
    };
}
